module.exports = __webpack_public_path__ + "img/pres-10.721ff310.png";